export enum AuditoriaAccion {
    PANTALLA_ACCESO = 'PANTALLA_ACCESO',
    VISUALIZAR = 'VISUALIZAR',
    CREAR_CON_PDF = 'CREAR_CON_PDF',
    CREAR_SIN_PDF = 'CREAR_SIN_PDF',
    EDITAR_CON_PDF = 'EDITAR_CON_PDF',
    EDITAR_SIN_PDF = 'EDITAR_SIN_PDF',

    // Flujo de inscripción O.S. (eventos de trazabilidad)
    INSCRIPCION_INICIO = 'INSCRIPCION_INICIO',
    REGISTRO_OK = 'REGISTRO_OK',
    REGISTRO_ERROR = 'REGISTRO_ERROR',
    RECUPERACION_CUENTA = 'RECUPERACION_CUENTA',
    SOLICITUD_CREADA = 'SOLICITUD_CREADA',
    SOLICITUD_ERROR = 'SOLICITUD_ERROR',
    UPLOAD_OK = 'UPLOAD_OK',
    UPLOAD_ERROR = 'UPLOAD_ERROR',
    COMPRESION_OK = 'COMPRESION_OK',
    INSCRIPCION_ERROR = 'INSCRIPCION_ERROR',
    GLOBAL_ERROR = 'GLOBAL_ERROR',
    TIMEOUT = 'TIMEOUT',
    DDJJ_OK = 'DDJJ_OK',
    DDJJ_ERROR = 'DDJJ_ERROR',
    INSCRIPCION_FIN = 'INSCRIPCION_FIN',
}

export enum AuditoriaModulo {
    COSEGUROS = 'Coseguros',
    PLANES = 'Planes',
    INSCRIPCION_OS = 'InscripcionOS',
}

export enum AuditoriaPantalla {
    COSEGUROS = 'Coseguros',
    PLAN_ALTA = 'PlanAlta',
    PLAN_MODIFICACION = 'PlanModificacion',
    INSCRIPCION_OS = 'InscripcionOS',
}

export enum AuditoriaRecurso {
    PLAN = 'Plan',
    PDF_COSEGUROS = 'PDFCoseguros',
}

export enum AuditoriaResultado {
    EXITO = 'EXITO',
    ERROR = 'ERROR',
}

export enum AuditoriaAudiencia {
    AFILIADOS = 'Afiliados',
    ADMINISTRADORES = 'Administradores',
}
